import { axiosInstance } from '@/api/client';

/**
 * Dohvaća autenticirani binarni resurs (npr. generirani PDF) i otvara ga u novoj kartici preko
 * object URL-a — isti obrazac kao useAuthenticatedImage (axiosInstance s responseType: 'blob',
 * jer <a href>/window.open na goli API URL ne bi poslao Authorization header). Za razliku od
 * useAuthenticatedImage (mount-triggered, za trajni <img>), ovo je jednokratna, on-demand akcija
 * (klik na "Pregled"), pa je obična async funkcija, ne hook.
 */
export const openBinaryInNewTab = async (url: string): Promise<void> => {
  const response = await axiosInstance.get(url, { responseType: 'blob' });
  const objectUrl = URL.createObjectURL(response.data);
  window.open(objectUrl, '_blank', 'noopener');
  // Odgođen revoke — nova kartica treba vremena da učita blob prije nego URL prestane vrijediti.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
};
